import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  description: {
    marginBottom: "15px",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "19px",
    color: "#465869"
  }
}));

export default styles;
